import React from 'react'
import PropTypes from 'prop-types'

const ConversionStats = ({
  conversionStats: {
    totalLeads,
    totalLeadsLast30,
    totalLeadsPrev30,
    totalConversions,
    meanConversionTime,
  },
}) => (
  <div className="conversionStats">
    <div className="conversionStatBox">
      <h4>Active Leads</h4>
      <p>{totalLeads}</p>
    </div>
    <div className="conversionStatBox">
      <h4>Total Leads in Last 30 Days</h4>
      <p>{totalLeadsLast30}</p>
    </div>
    <div className="conversionStatBox">
      <h4>Total Leads in Previous 30 Days</h4>
      <p>{totalLeadsPrev30}</p>
    </div>
    <div className="conversionStatBox">
      <h4>Total Conversions</h4>
      <p>{totalConversions}</p>
    </div>
    <div className="conversionStatBox">
      <h4>Average Conversion Time</h4>
      { meanConversionTime
        ? <p>{meanConversionTime} days</p>
        : <p>n/a</p>
      }
    </div>
  </div>
)

ConversionStats.propTypes = {
  conversionStats: PropTypes.object.isRequired,
}

export default ConversionStats



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactsTab/ConversionStats.js